import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { NotyService } from '../../../services/common/noty.service';
import { TaxObligationService } from '../../../services/accounting/tax-obligation.service';
import { UserService } from '../../../services/users/user.service';

declare var window: any;

@Component({
  selector: 'app-tax-obligation-index',
  templateUrl: './tax-obligation-index.component.html',
  styleUrls: ['./tax-obligation-index.component.scss'],
})
export class TaxObligationIndexComponent implements OnInit {
  creatingPayment: boolean = false;

  makingPayment: boolean = false;

  paymentChecks: Array<any> = [];

  paymentMode: boolean = false;

  taxObligations: any = {
    auto_tax_obligations: [],
    other_tax_obligations: [],
    auto_tax_obligations_total: 0,
    other_tax_obligations_total: 0,
    auto_tax_obligations_all_select: false,
    other_tax_obligations_all_select: false,
  };

  paymentNgbModalRef: NgbModalRef | null;

  @ViewChild('paymentModal', { static: true }) paymentModalTemplate: TemplateRef<any>;

  constructor(private modalService: NgbModal, private notyService: NotyService, private taxObligationService: TaxObligationService, private userService: UserService) {}

  // Component lifecycle events
  ngOnInit() {
    this.userService.navbarComponent.setTaxesMenu();
    this.taxObligationService.index().then((response_json) => {
      this.taxObligations = response_json;
      this.calculateTotals();
    });
  }

  // Component methods
  allSelect(forTaxes: string) {
    switch (forTaxes) {
      case 'auto_tax_obligations':
        for (let tax of this.taxObligations.auto_tax_obligations) tax.selected = this.taxObligations.auto_tax_obligations_all_select;
        break;
      case 'other_tax_obligations':
        for (let tax of this.taxObligations.other_tax_obligations) tax.selected = this.taxObligations.other_tax_obligations_all_select;
        break;
    }
  }

  calculatePaymentChecksTaxTotal() {
    for (let paymentCheck of this.paymentChecks) {
      let taxTotal: number = 0;
      for (let tax of paymentCheck.taxes) taxTotal += Number(tax.amount || 0);
      paymentCheck.taxTotal = taxTotal;
    }
  }

  calculateTotals() {
    this.taxObligations.auto_tax_obligations_total = 0;
    this.taxObligations.other_tax_obligations_total = 0;
    for (let tax of this.taxObligations.auto_tax_obligations) this.taxObligations.auto_tax_obligations_total += Number(tax.outstanding || 0);
    for (let tax of this.taxObligations.other_tax_obligations) this.taxObligations.other_tax_obligations_total += Number(tax.outstanding || 0);
  }

  createPayment() {
    this.creatingPayment = true;
    this.taxObligationService
      .createPayment(this.paymentChecks)
      .then((response_json) => {
        this.creatingPayment = false;
        this.notyService.notify(response_json.text || 'Taxes paid successfully', 'success');
        if (this.paymentNgbModalRef) {
          this.paymentNgbModalRef.close();
          this.paymentNgbModalRef = null;
        }
        if (response_json.entry_group_id) window.location.href = `/entry_groups/${response_json.entry_group_id}`;
      })
      .catch(() => {
        this.creatingPayment = false;
        this.notyService.notify('Error creating payment', 'error');
      });
  }

  makePayment() {
    let tax_ids: Array<number> = [];
    let tax_obligation_ids: Array<number> = [];
    for (let tax of this.taxObligations.auto_tax_obligations) {
      if (tax.selected) tax_ids.push(tax.id);
      for (let taxObligation of tax.tax_obligations) if (taxObligation.selected) tax_obligation_ids.push(taxObligation.id);
    }
    for (let tax of this.taxObligations.other_tax_obligations) {
      if (tax.selected) tax_ids.push(tax.id);
      for (let taxObligation of tax.tax_obligations) if (taxObligation.selected) tax_obligation_ids.push(taxObligation.id);
    }
    if (tax_ids.length < 1 && tax_obligation_ids.length < 1) this.notyService.notify('No tax or tax obligation selected', 'warning');
    else {
      this.makingPayment = true;
      this.taxObligationService
        .newPayment(tax_ids, tax_obligation_ids)
        .then((response_json) => {
          this.makingPayment = false;
          this.paymentChecks = response_json;
          this.paymentMode = true;
          this.calculatePaymentChecksTaxTotal();
          this.paymentNgbModalRef = this.modalService.open(this.paymentModalTemplate);
          this.paymentNgbModalRef.result.then(
            (result) => {},
            (reason) => {}
          );
        })
        .catch(() => {
          this.makingPayment = false;
          this.notyService.notify('Error preparing payment for tax obligations', 'error');
        });
    }
  }
}
